import { Text } from '@/components/commons/typography/Text'
import { Title } from '@/components/commons/typography/Title'
import { cssClass } from '@/shared/utils'
import { useHighlightError } from 'containers/highlights/hooks/useHighlights'
import {
  contentTypeName,
  getHighlightContentType,
} from 'containers/highlights/misc/highlightContentType'
import { useHighlightEditorStore } from 'containers/highlights/store/highlightEditor'
import { HighlightPostContentType } from 'containers/highlights/types/highlights'
import { useEffect } from 'react'

export const HContentTypeSelector = () => {
  const { highlight, updateHighlight } = useHighlightEditorStore()
  const { errorMessage } = useHighlightError('contentType')

  const types = Object.keys(HighlightPostContentType || {})

  useEffect(() => {
    if (highlight?.contentLink) {
      const type = getHighlightContentType(highlight?.contentLink)
      updateHighlight({
        contentType: type as HighlightPostContentType,
      })
    }
  }, [highlight?.contentLink, updateHighlight])

  const isContentTypeSelected = (type: string) => {
    return highlight?.contentType === type.toLocaleLowerCase()
  }

  const onContentTypeClick = (type: string) => {
    if (!isContentTypeSelected(type)) {
      updateHighlight({
        contentType: type.toLocaleLowerCase() as HighlightPostContentType,
      })
    }
  }

  return (
    <div className="flex flex-column gap-8">
      <Title as="label" variation="xSmall">
        Select Content Type{' '}
        <Text as="sup" colorClass="text-info">
          *
        </Text>
      </Title>
      <div className="flex gap-8 wrap">
        {types.map((type, index) => (
          <div
            key={type + index}
            className={cssClass([
              'px-16 py-8 border rounded-8 cursor-pointer',
              isContentTypeSelected(type)
                ? 'bg-accent-tertiary-light'
                : 'bg-tertiary ',
            ])}
            onClick={() => onContentTypeClick(type)}
          >
            <Text
              colorClass={
                isContentTypeSelected(type) ? 'text-info' : 'text-tertirary'
              }
              variation="xSmall"
              lineHeightClass="leading-20"
            >
              {contentTypeName(type as HighlightPostContentType)}
            </Text>
          </div>
        ))}
      </div>
      {errorMessage && (
        <Text variation="xSmall" colorClass="text-danger">
          {errorMessage}
        </Text>
      )}
    </div>
  )
}
